import React from 'react'

import { OpeningRow, PaginationIcon } from './Styles'
import { ReactComponent as ArrowRight } from 'assets/images/XSArrowRight.svg'
import { ReactComponent as ArrowLeft } from 'assets/images/XSArrowLeft.svg'

interface Props {
  currentCountEnd: number
  currentCountStart: number
  totalCount: number
  switchPage: (dir: number) => void
}

const RoutesFooter = ({
  currentCountEnd,
  currentCountStart,
  totalCount,
  switchPage,
}: Props) => (
  <OpeningRow>
    <PaginationIcon onClick={() => switchPage(-1)}>
      <ArrowLeft />
    </PaginationIcon>
    <p>
      Showing{' '}
      {currentCountStart === currentCountEnd
        ? currentCountEnd
        : `${currentCountStart}-${currentCountEnd}`}{' '}
      out of {totalCount} routes
    </p>
    <PaginationIcon onClick={() => switchPage(1)}>
      <ArrowRight />
    </PaginationIcon>
  </OpeningRow>
)

export default React.memo(RoutesFooter)
